export default "__VITE_ASSET__ca1c15e1__"